import { PrerenderData } from '../prerender/data';
import { useContext, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyMetadata, getPageMetadata } from './metadata';

export default function RouteMetadata() {
  const { pathname } = useLocation();
  const initial = useContext(PrerenderData);
  useLayoutEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const data = { ...getPageMetadata(pathname), ...(initial?.pathname === path ? initial.metadata : {}) };
    if (window.location.hostname.startsWith('admin.')) data.noindex = true;
    applyMetadata(data);
  }, [pathname, initial]);
  return null;
}
